import React, { useEffect, useRef, useState } from "react";
import styles from "./LandingPage.module.scss";
import textImage from "../../Components/assets/Images/firstocktextimage.svg";
import SouthIcon from "@mui/icons-material/South";
import VibrationRoundedIcon from "@mui/icons-material/VibrationRounded";
import rekycimage from "../../Components/assets/Images/rekycimage.svg";
import finupdateimage from "../../Components/assets/Images/financialupdateimage.svg";
import bankupdateimage from "../../Components/assets/Images/bankupdateimage.svg";
import loginupdateimage from "../../Components/assets/Images/loginupdateimage.svg";
import segmentimage from "../../Components/assets/Images/segmentimage.svg";
import nomineeimage from "../../Components/assets/Images/nomineeupdateimage.svg";
import ddpiimage from "../../Components/assets/Images/ddpiimage.svg";
import accountclosureimage from "../../Components/assets/Images/accountclosureimage.svg";
import doneicon from "../../Components/assets/Images/updatedoneicon.svg";
import getstartedimage from "../../Components/assets/Images/updategetstarted.svg";
import circleshape from "../../Components/assets/Images/circleshape.svg";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { useNavigate } from "react-router-dom";
import { getCookie, setCookie } from "../../shared/cookies";
import { APPID, ENV, TRADINGAPP, TOKENNAME } from "../../shared/constants";
import axios from "axios";
import { LocationCheckAPICall } from "../../shared/APICalls";
import { CircularProgress } from "@mui/material";

const labels = [
  "Financial Update",
  "Bank Update",
  "Email & Mobile Update",
  "DDPI",
  "Segment Update",
  "Nominee Update",

  "Account Closure",
];

const data = {
  //   "RE KYC": {
  //     title: "RE KYC",
  //     header: "Ensure Your Account Security with ReKYC",
  //     desc: "ReKYC is essential to keep your account information up-to-date and compliant with regulatory standards. This ensures your account remains secure and your personal details are accurate.",
  //     point1: "Upload your ID and address proof quickly and securely.",
  //     point2:
  //       "Your information will be verified promptly to avoid any disruptions.",
  //     point3: "Regular updates ensure your account is protected against fraud.",
  //     point4: "Stay compliant with the latest financial regulations.",
  //     point5: "Receive timely notifications to update your KYC information.",
  //     link: "",
  //     image: rekycimage,
  //   },
  "Financial Update": {
    title: "Financial Update",
    header: "Keep Your Financial Information Current",
    desc: "Updating your financial information ensures your account reflects your most accurate and up-to-date details. This is crucial for maintaining accurate records and ensuring smooth transactions.",
    point1: "Quickly and securely update your financial details.",
    point2: "Ensure all your financial information is current and correct.",
    point3: "Stay compliant with financial regulations and standards.",
    point4: "Your financial information is protected with top-tier security.",
    point5: "Access and review updated financial information easily.",
    link: "/finupdate",
    navigateLink: "finupdate",
    image: finupdateimage,
  },
  "Bank Update": {
    title: "Bank Update",
    header: "Keep Your Bank Details Up-to-Date",
    desc: "Updating your bank details is essential to ensure seamless transactions and accurate financial records. Keep your account information current to avoid any disruptions in your financial activities.",
    point1: "Quickly and securely update your bank details.",
    point2:
      "Ensure uninterrupted financial transactions with up-to-date information.",
    point3: "Protect your account with secure data handling.",
    point4: "Easily navigate through the bank updation process.",
    point5: "Access and review updated bank information easily.",
    link: "/bankupdate",
    navigateLink: "bankupdate",
    image: bankupdateimage,
  },
  "Email & Mobile Update": {
    title: "Email & Mobile Update",
    header: "Update Your Login Information Effortlessly",
    desc: "Keeping your Login information, such as email and phone number, up-to-date is crucial for maintaining effective communication and ensuring your  account security.",
    point1: "Quickly and securely update your email and phone number.",
    point2:
      "Ensure you receive important notifications and updates without interruption.",
    point3: "Protect your account by keeping your contact details current.",
    point4: "Stay compliant with Login data regulations and standards.",
    point5:
      "Receive immediate confirmation once your Login details are updated.",
    link: "/emailandmobileupdate",
    navigateLink: "emailandmobileupdate",
    image: loginupdateimage,
  },
  DDPI: {
    title: "DDPI",
    header: "Streamline Your Transactions with DDPI Updation",
    desc: "Updating your DDPI ensures that your demat account operations remain efficient and secure. This process helps maintain accurate and authorized transactions for debits and pledges.",
    point1: "Simplify debits and pledges with updated instructions.",
    point2: "Ensure safe and verified handling of your securities.",
    point3: "Stay aligned with the latest financial regulations.",
    point4: "Get real-time alerts for every updated instruction.",
    point5: "Access comprehensive records of all your updated transactions.",
    link: "/ddpi",
    navigateLink: "ddpi",
    image: ddpiimage,
  },
  "Segment Update": {
    title: "Segment Update",
    header: "Expand Your Trading Horizons",
    desc: "Segment activation in trading allows investors to access and invest in a variety of asset classes across different exchanges. This includes segments for mutual funds, futures and options, currencies, and commodities, offering a diversified investment approach.",
    point1:
      "Access mutual funds, futures, options, currencies, and commodities.",
    point2: "Easily activate and manage different trading segments.",
    point3:
      "Receive timely updates and notifications about your segment activities.",
    point4:
      "Integrate new segments into your existing trading setup effortlessly.",
    point5: "Activate and manage segments anytime, from anywhere.",
    link: "/segmentUpdate",
    navigateLink: "segmentUpdate",
    image: segmentimage,
  },
  "Nominee Update": {
    title: "Nominee Update",
    header: "Keep Your Nominee Information Current",
    desc: "Updating your nominee details is crucial for ensuring that your assets are allocated according to your wishes. Maintain accurate and up-to-date nominee information to manage your account effectively.",
    point1: "Protect your account by keeping nominee information current.",
    point2: "Stay in line with regulatory requirements for nominee details.",
    point3:
      "Receive immediate confirmation once your nominee details are updated.",
    point4: "Update nominee information anytime, from anywhere.",
    point5: "Access and review updated nominee information effortlessly.",
    link: "/nomineeUpdate",
    navigateLink: "nomineeUpdate",
    image: nomineeimage,
  },

  "Account Closure": {
    title: "Account Closure",
    header: "Close Your Demat Account with Ease",
    desc: "Closing your demat account is a straightforward process that ensures your financial records are managed efficiently. Whether you're consolidating accounts or no longer need your demat account, we make the closure process quick and hassle-free.",
    point1: "Easily follow the steps to close your demat account.",
    point2: "Ensure the safe and secure handling of your account closure.",
    point3: "Adhere to all regulatory requirements for account closure.",
    point4: "Receive detailed guidance on required documentation.",
    point5: "Receive immediate confirmation of your account closure.",
    link: "/account_closure",
    navigateLink: "account_closure",
    image: accountclosureimage,
  },
};

function LandingPage() {
  // setCookie("userId", "KC1593", 10);
  // setCookie("deviceId", "c2842e96-fac1-1f2a-1ebd-85919da16bb7", 10);
  // setCookie(
  //   "access_token",
  //   "S0MxNTkzfGMxNjA1MWI2NDUwZjFlMGJiZGI0MzRlMTBkODYxYmJkMmRiMDA5NDBiYTU5NGM0MzdlZjdlYjlmNjJlOTQ1ZDZ8YzI4NDJlOTYtZmFjMS0xZjJhLTFlYmQtODU5MTlkYTE2YmI3fDE3NTQ2MzQxMTV8OUVSZ2R5d2h5anFKUUlJanQ0NDZGUUFBc3EtZm5LNDctMVBFRW9Ec2hpND0=",
  //   10
  // );

  const [selectedTab, setselectedTab] = useState("Financial Update");
  const navigate = useNavigate();
  const ref: any = useRef(null);

  const [showContent, setshowContent] = useState(false);
  const [latitude, setlatitude] = useState("");
  const [loading, setLoading] = useState(true);
  const [IPAddress, setIPAddress] = useState("");
  const cookieData = getCookie("access_token");

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   const fetchIPAddress = async () => {
  //     try {
  //       const response = await axios.get("https://checkip.amazonaws.com/");
  //       setIPAddress(response.data);
  //     } catch (err: any) {}
  //   };
  //   fetchIPAddress();
  // }, []);

  // useEffect(() => {
  //   if (IPAddress !== "") {
  //     setLoading(true);
  //     LocationCheckAPICall(IPAddress?.trim())
  //       .then((response: any) => {
  //         // console.log("responselocation", response.data.data);
  //         setLoading(false);
  //         if (response.data.data) {
  //           setlatitude(response.data.data.latitude);
  //           sessionStorage.setItem("latitude", response.data.data.latitude);
  //           sessionStorage.setItem("longitude", response.data.data.longitude);
  //           setshowContent(true);
  //         }
  //       })
  //       .catch((error: any) => {
  //         // console.log("error", error);
  //         setLoading(false);
  //         setshowContent(false);
  //       });
  //   }
  // }, [IPAddress]);

  const onChangeTab = (item: any) => {
    setselectedTab(item);
  };
  const handleNavigate = () => {
    //  const callBackURL = `${document.location.href}`;
    const callBackURL = `${document.location.href}${data[selectedTab].navigateLink}`;
    // console.log("callBackURL", callBackURL);
    if (cookieData) {
      navigate(data[selectedTab].link);
    } else {
      // if (latitude) {
      window.location.href = `${TRADINGAPP}?callback=${callBackURL}`;
      // } else {
      //   window.alert("Location details not found");
      // }
    }
  };

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <div className={styles.topLeft}>
            <p className={styles.topTitle}>
              Effortlessly Manage Your Updates with Firstock
            </p>
            <p className={styles.topDesc}>
              Quick and easy access to update your personal and financial
              information in one place.
            </p>
          </div>
          {/* <div className={styles.topRight} onClick={handleNavigate}>
            Get Started
          </div> */}
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.leftContent}>
            <img src={data[selectedTab].image} className={styles.image} />
          </div>
          <div className={styles.rightContent}>
            <div className={styles.categories}>Categories</div>
            <div className={styles.tabsWrapper} ref={ref}>
              <div className={styles.tabsCatagory}>
                {labels.map((a: any, index: any) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className={styles.tabsItem}
                      onClick={() => onChangeTab(a)}
                      style={{
                        backgroundColor: selectedTab === a ? "#1F2937" : "",
                        color: selectedTab === a ? "white" : "",
                        cursor: "pointer",
                      }}
                    >
                      <VibrationRoundedIcon
                        style={{ transform: "rotate(90deg)", fontSize: "12px" }}
                      />{" "}
                      {a}
                    </div>
                    {index !== labels.length - 1 && (
                      <div className={styles.dot}></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "10px 0px",
              }}
            >
              <div className={styles.rightContenttitle}>
                {data[selectedTab].title}
              </div>

              {/* {showContent ? ( */}
              <div
                className={styles.topRight}
                onClick={() => {
                  handleNavigate();
                }}
              >
                Get Started
              </div>
              {/* ) : (
                <>
                  {loading ? (
                    <div
                      className={styles.topRight}
                      style={{
                        background: "grey",
                        width: "147px",
                        padding: "0px 10px",
                        color: "black",
                      }}
                    >
                      <CircularProgress
                        color="inherit"
                        style={{ height: "20px", width: "20px" }}
                      />
                    </div>
                  ) : (
                    <div
                      className={styles.topRight}
                      style={{
                        background: "grey",
                        width: "max-content",
                        padding: "0px 30px",
                        color: "red",
                      }}
                    >
                      Location access is required
                    </div>
                  )}
                </>
              )} */}
            </div>

            <p className={styles.rightContentHeader}>
              {data[selectedTab].header}
            </p>
            <p className={styles.rightContentDesc}>{data[selectedTab].desc}</p>
            <div className={styles.points}>
              <img src={doneicon} className={styles.doneicon} />
              <p className={styles.description}>{data[selectedTab].point1}</p>
            </div>
            <div className={styles.points}>
              <img src={doneicon} className={styles.doneicon} />
              <p className={styles.description}>{data[selectedTab].point2}</p>
            </div>
            <div className={styles.points}>
              <img src={doneicon} className={styles.doneicon} />
              <p className={styles.description}>{data[selectedTab].point3}</p>
            </div>
            <div className={styles.points}>
              <img src={doneicon} className={styles.doneicon} />
              <p className={styles.description}>{data[selectedTab].point4}</p>
            </div>
            <div className={styles.points}>
              <img src={doneicon} className={styles.doneicon} />
              <p className={styles.description}>{data[selectedTab].point5}</p>
            </div>
            {/* <div className={styles.getStartedSection} onClick={handleNavigate}>
            <img src={circleshape} className={styles.circleImage} />
            <div className={styles.circle}>
              <ArrowForwardRoundedIcon />
            </div>
            <p className={styles.getStartedtext}>Get Started</p>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
